/**
 * 「最後に始めた読み込みだけが、画面の状態を更新してよい」を表す小さな仕組み（指示書 A-17）。
 *
 *   const loads = createLatestOnly()
 *   const isCurrent = loads.begin()
 *   const data = await fetch...
 *   if (!isCurrent()) return   // 後から別の読み込みが始まっていたら、この結果は使わない
 */
export function createLatestOnly() {
  let generation = 0
  return {
    /** 新しい読み込みを始める。返す関数は、この読み込みがまだ最新かを答える */
    begin() {
      const mine = ++generation
      return () => mine === generation
    }
  }
}
